module.exports = __webpack_public_path__ + "static/media/logo_light.92fb3338.png";